import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id B7386AC8-4DBF-4948-AD45-49234A8A019B
 * name flag-checkered
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-checkered.svg
 * tags
 * - Sport 
 */
export const FlagCheckeredIcon = createSvgIcon(<><path d="M14.4,6H20V16H13L12.6,14H7V21H5V4H14L14.4,6M14,14H16V12H18V10H16V8H14V10L13,8V6H11V8H9V6H7V8H9V10H7V12H9V10H11V12H13V10L14,12V14M11,10V8H13V10H11M14,10H16V12H14V10Z" /></>, 'FlagCheckeredIcon');
export default FlagCheckeredIcon